import makeStyles from "e100-react-components/lib/styles/makeStyles";

export const useStyles = makeStyles(({ spacing, typography }) => ({
  container: {
    "& > *": {
      margin: spacing(0.5),
    },
  },
  badge: {
    backgroundColor: "rgba(155, 164, 176, .08)",
    fontSize: typography.pxToRem(11),
  },
  avatar: {
    display: 'inline-block',
    width: `${spacing(1.5)}px !important`,
    '& > *': {
      marginLeft: spacing(0.8),
      top: 1
    }
  },
  lastUpdateText: {
    lineHeight: typography.h5.fontSize
  }
}));
